import { Box, Text } from '@fhs-legacy/universal-components';

export const InstructionText = Text.withConfig({
  marginTop: '$3',
  marginX: 0,
  marginBottom: '$2.5',
  fontSize: 'sm',
  width: '100%',
  padding: 0,
  fontWeight: '700',
});

export const ReloadWrapper = Box.withConfig({
  marginX: 0,
  marginY: '$4',
});
